// Canonical content pages that appear in the sidebar. Staff access to these is
// admin-configurable. "settings" and "update-requests" are handled separately.
export const CONTENT_PAGES = [
  { key: "dashboard", label: "Dashboard", path: "/dashboard" },
  { key: "stock-on-hand", label: "Stock on Hand", path: "/stock-on-hand" },
  { key: "incoming-stock", label: "Incoming Stock", path: "/incoming-stock" },
  { key: "to-order", label: "Ordering", path: "/to-order" },
  { key: "manufacturers", label: "Manufacturers", path: "/manufacturers" },
  { key: "series", label: "Series", path: "/series" },
  { key: "products", label: "Products", path: "/products" },
  { key: "browse", label: "Browse", path: "/browse" },
  { key: "rolls", label: "Rolls", path: "/rolls" },
  { key: "scan", label: "Scan", path: "/scan" },
  { key: "per-unit-products", label: "Per Unit Products", path: "/per-unit-products" },
  { key: "cuts", label: "Cuts", path: "/cuts" },
  { key: "stock-take", label: "Stock Take", path: "/stock-take" },
  { key: "alerts", label: "Alerts", path: "/alerts" },
  { key: "reports", label: "Analytics", path: "/reports" },
  { key: "archive", label: "Archive", path: "/archive" },
];

export const ALL_CONTENT_KEYS = CONTENT_PAGES.map((p) => p.key);

// Resolve a pathname to its page key (handles nested routes like /rolls/:id
// and /browse/product/:id by matching the longest configured path prefix).
export function pageKeyForPath(pathname) {
  if (pathname === "/settings" || pathname.startsWith("/settings/")) return "settings";
  if (pathname === "/update-requests" || pathname.startsWith("/update-requests/")) return "update-requests";
  if (pathname === "/activity-log" || pathname.startsWith("/activity-log/")) return "activity-log";
  if (pathname === "/product-radar" || pathname.startsWith("/product-radar/")) return "product-radar";
  const match = [...CONTENT_PAGES]
    .sort((a, b) => b.path.length - a.path.length)
    .find((p) => pathname === p.path || pathname.startsWith(p.path + "/"));
  return match ? match.key : null;
}
